module.exports = __webpack_public_path__ + "static/media/alpine.d567f193.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/images/alpine.jpg
 ** module id = 424
 ** module chunks = 0
 **/